import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { faqs } from "@/config/site";

export const FAQ = () => (
  <section data-testid="faq-section" className="relative bg-ivory py-24 sm:py-32">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <div className="text-center mb-14">
        <Reveal className="flex justify-center"><Eyebrow>FAQ</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-charcoal">
            Questions, <span className="italic text-maroon">answered.</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-champagne/25 bg-white px-6 data-[state=open]:border-champagne/60"
            >
              <AccordionTrigger className="py-5 text-left font-display text-lg text-charcoal hover:text-maroon hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-charcoal/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
